import fromPairs from 'lodash/fromPairs'
import { getUrlParam } from '../../utils/UrlUtils'
import pick from 'lodash/pick'
import mapKeys from 'lodash/mapKeys'

const FACEBOOK_PIXEL_UTM_PARAMS = [
  'utm_source',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_campaign_id',
  'utm_medium',
  'utm_adset_id',
  'utm_ad_id',
]

export function getCurrentUtmParams() {
  return fromPairs(
    FACEBOOK_PIXEL_UTM_PARAMS.map((param) => [
      param,
      getUrlParam(param) || null,
    ])
  )
}

export function getInitialUtmParams(initialUserParams) {
  let initialUtmParams = fromPairs(
    FACEBOOK_PIXEL_UTM_PARAMS.map((param) => [param, null])
  )
  const initialUtmParamsFromServer = pick(
    initialUserParams.utmParams || {},
    FACEBOOK_PIXEL_UTM_PARAMS
  )
  initialUtmParams = { ...initialUtmParams, ...initialUtmParamsFromServer }
  return mapKeys(initialUtmParams, (_, key) => `initial_${key}`)
}
